(() => {
  const grids = document.querySelectorAll(".fm-o-service-grid");
  if (grids.length === 0) return;
  grids.forEach((grid) => {
    const loadMoreBtn = grid.querySelector(".fm-o-service-grid__load-more-btn-container > button");
    if (loadMoreBtn)
      loadMoreBtn.addEventListener("click", () => {
        grid.classList.add("expanded");
      });
  });
})();
